import { render, staticRenderFns } from "./PainelUsuario.vue?vue&type=template&id=3d27985d&"
import script from "./PainelUsuario.vue?vue&type=script&lang=js&"
export * from "./PainelUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports